class CommentSwiper {
  id;
  swiper;
  options;
  isPlaying = true;
  disable = false;
  lastNeedSwiperSpeed;
  constructor(id, options) {
    this.options = options;
    this.id = id;
    this.isPlaying = true;
    this.startTimer = null;
    this.initSplide();
  }

  initSplide() {
    const defaultOptions = {
      loop: true,
      longSwipesRatio: 0.1,
      slidesPerView: 2.2,
      allowTouchMove: false,
      speed: 3000,
      pauseOnMouseEnter: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    };
    // 创建 Swiper 实例
    this.swiper = new Swiper(this.id, this.options || defaultOptions);
  }
  start() {
    try {
      this.isPlaying = true;
      this.swiper.slideTo(this.swiper.activeIndex, this.lastNeedSwiperSpeed);
      setTimeout(() => {
        this.swiper.autoplay.start();
      }, 500);
      // this.swiper.autoplay.start();
    } catch (error) {
      console.log('startError', error);
    }
  }
  stop() {
    try {
      this.isPlaying = false;
      const currentSlideWidth =
        this.swiper.slides[this.swiper.activeIndex].offsetWidth;
      this.lastNeedSwiperSpeed =
        (Math.abs(
          Math.abs(this.swiper.getTranslate()) - Math.abs(this.swiper.translate)
        ) /
          (currentSlideWidth + this.swiper.params.spaceBetween)) *
        this.swiper.params.speed;
      this.swiper.setTranslate(this.swiper.getTranslate());
      this.swiper.autoplay.stop();
      this.isPlaying = false;
    } catch (error) {
      console.log('stopError', error);
    }
  }

  async handlePlay() {
    await this.start();
  }
  async handlePause() {
    await this.stop();
  }
}
